document.addEventListener("DOMContentLoaded", function () {

    const header = document.getElementById("CustomHeader");
    const toggle = document.getElementById("MobileMenuToggle");
    const closeBtn = document.getElementById("MobileClose");
    const drawer = document.getElementById("MobileNavigation");
    const overlay = document.getElementById("MobileOverlay");

    if (!header) return;

    /* -----------------------------
       Sticky Header
    ----------------------------- */

    function updateHeader() {

        if (window.scrollY > 40) {

            header.classList.add("scrolled");

        } else {

            header.classList.remove("scrolled");

        }

    }

    updateHeader();

    window.addEventListener("scroll", updateHeader, {
        passive: true
    });

    /* -----------------------------
       Mobile Drawer
    ----------------------------- */

    function openMenu() {

        drawer.classList.add("open");
        overlay.classList.add("open");

        toggle.classList.add("active");

        toggle.setAttribute("aria-expanded", "true");

        document.body.classList.add("mobile-menu-open");

    }

    function closeMenu() {

        drawer.classList.remove("open");
        overlay.classList.remove("open");

        toggle.classList.remove("active");

        toggle.setAttribute("aria-expanded", "false");

        document.body.classList.remove("mobile-menu-open");

    }

    if (toggle) {

        toggle.addEventListener("click", function () {

            if (drawer.classList.contains("open")) {

                closeMenu();

            } else {

                openMenu();

            }

        });

    }

    if (closeBtn) {

        closeBtn.addEventListener("click", closeMenu);

    }

    if (overlay) {

        overlay.addEventListener("click", closeMenu);

    }

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {

            closeMenu();

        }

    });

    drawer.querySelectorAll("a").forEach(function (link) {

        link.addEventListener("click", closeMenu);

    });

});